import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogSurface,
} from "@fluentui/react-components";

export interface BlockingDialogProps {
	isOpen: boolean;
	text: string;
}

export const BlockingDialog = (props: BlockingDialogProps) => {
	return (
		<Dialog open={props.isOpen} modalType="alert">
			<DialogSurface>
				<DialogBody>
					<DialogContent>{props.text}</DialogContent>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
};
